import type { BackendModule, CallbackError, Services } from 'i18next';

interface LazyLoadOptions {
  loadPath: string;
}

interface LazyLoad extends BackendModule<LazyLoadOptions> {
  services?: Services;
  options?: LazyLoadOptions;
}

export const lazyLoad: LazyLoad = {
  type: 'backend',
  init(services, options) {
    this.services = services;
    this.options = options;
  },
  async read(language, _namespace, callback) {
    const loadPath = this.options?.loadPath;
    if (!loadPath) {
      callback(new Error('lazyLoad backend was not initialized with loadPath'), null);
      return;
    }
    try {
      const response = await fetch(loadPath.replace('{{lng}}', language));
      if (!response.ok) {
        throw new Error(`Failed to load translations for ${language}`);
      }
      const data = await response.json();
      callback(null, data);
    } catch (error) {
      callback(error as CallbackError, null);
    }
  }
};